// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"72":"440cc785b740e32657d6","352":"42fd955f86d251a42990"}[chunkId] + ".bundle.js";
};